import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
export const AccordionItem = styled.div`
  border: 1px solid #e6e8eb;
  border-radius: 8px;
  overflow: hidden;
`
export const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  cursor: pointer;
  font-weight: 700;
  font-size: 14px;
  background: #f7f8f9;
  &:hover {
    background: #eceef1;
  }
`
export const Chevron = styled.span<{ open: boolean }>`
  transition: transform 0.2s;
  transform: rotate(${p => (p.open ? '0deg' : '-90deg')});
`
export const AccordionBody = styled.div`
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #fff;
`
export const Field = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  label {
    font-size: 13px;
    font-weight: 600;
    color: #555;
    white-space: nowrap;
  }

  input,
  select {
    padding: 6px 10px;
    border-radius: 6px;
    border: 1px solid #d0d3d8;
    font-size: 14px;
    min-width: 140px;
  }
`
export const SubmitBtn = styled.button`
  padding: 8px 16px;
  border-radius: 6px;
  background: #171a1c;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  border: none;
  cursor: pointer;
  align-self: flex-end;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`
export const ToggleWrapper = styled.div<{ active: boolean }>`
  width: 40px;
  height: 22px;
  border-radius: 11px;
  background: ${p => (p.active ? '#171a1c' : '#d0d3d8')};
  cursor: pointer;
  position: relative;
  transition: background 0.2s;
  flex-shrink: 0;
`
export const ToggleThumb = styled.div<{ active: boolean }>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  position: absolute;
  top: 3px;
  left: ${p => (p.active ? '21px' : '3px')};
  transition: left 0.2s;
`
export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
